var crypto = require('crypto')

exports.createCipher = exports.Cipher = crypto.createCipher
exports.createCipheriv = exports.Cipheriv = crypto.createCipheriv
exports.createDecipher = exports.Decipher = crypto.createDecipher
exports.createDecipheriv = exports.Decipheriv = crypto.createDecipheriv
exports.listCiphers = exports.getCiphers = crypto.getCiphers



//////////////////
// WEBPACK FOOTER
// ./~/browserify-aes/index.js
// module id = 327
// module chunks = 0 1 2 3